import { JoiningProgress } from "@vivagym-joining/joining-progress";
import { LoadingStep } from "@vivagym-joining/vg-loading-step";

document.addEventListener("DOMContentLoaded", async () => {
	window.notificationsActive = true;
	window.loadMode = false;
	window.preSelectMode = false;

	let subscriptionsData = null;
	let gymBillingPeriod = 30;
	let pricePeriodLabel = '';
	let marketingOptions = null;
	let gymPreselectedInsurance = null;
	let isGymOpen = true;
	let availableGymsBy = null;
	let currentSelectedRadio = null;
	const vgApiClient = new VgApiClient(VgHelpers.getCountry(), VgHelpers.getLanguage());
	const loadingStep = new LoadingStep();

	const vgForms = new VGForms();
	let userSubscriptions = null;
	let gymId = null;

	JoiningProgress.onDataReady(initStep);

	async function initStep(progress) {

		console.log("Loaded progress data:", progress);

		gymId     = progress.getGymId();
		isGymOpen = progress.checkIfGymIsOpen(null);

		if (!gymId) {
			window.location.href = VgHelpers.getSelectedSlugForJoining('wizard_slug_joining_select_gym');
			return;
		}

		// NEW JOINING SWITCH: with ?skip_quote=1 the loading stays until the controller goes to the user data step.
		// Temporary, see vivagym-web/post-types/gym/vg_gym_new_joining.php (also preselectedByUrl and cancelSkipQuote).
		const skipQuote = new URLSearchParams(window.location.search).get('skip_quote') === '1';
		if (!skipQuote) {
			loadingStep.remove();
		}

		const nonceValidator = new VgFormsNonce();
	
		[, gymBillingPeriod, marketingOptions, subscriptionsData, gymPreselectedInsurance, availableGymsBy] = await Promise.all([
			nonceValidator.fetchAndSetNonce('vg_select_quote', 'vg_select_quote_nonce'),
			vgApiClient.getGymPricePeriod(gymId),
			vgApiClient.getGymMarketingOptions(gymId),
			vgApiClient.getSubscriptions(gymId, progress.getGymCountry()),
			vgApiClient.getGymPreselectedInsurance(gymId),
			vgApiClient.getSubscriptionsGymsBy(gymId),
		]);

		let countryPath = progress.getGymDomain();

		const step1resume = document.getElementById("step-1-resume");
		step1resume.style.display = "block";
		const quoteTable = document.querySelector(".vg-select-quote__table");
		userSubscriptions = progress.getSelectQuoteStep()?.data;

		vgForms.addLoading(step1resume);
		vgForms.addLoading(quoteTable);

		if (marketingOptions?.maintenance) {
			clearStep(progress);
			renderMaintenanceMessage(marketingOptions);

			if (marketingOptions?.banner) {
				renderGymBanner(marketingOptions);
			}

			loadingStep.remove();
			cancelSkipQuote(skipQuote);
			console.log("Gym is under maintenance, no subscriptions available.");
			return;
		}

		if (!subscriptionsData || !subscriptionsData.subscriptions || subscriptionsData.subscriptions.length === 0) {
			clearStep(progress);
			cancelSkipQuote(skipQuote);
			new VgModal({
				title: JoiningVars.get_form_field("modals").joining_select_quote_intern.title,
				description: JoiningVars.get_form_field("modals").joining_select_quote_intern.content,
				data: [],
				type: "error",
				template: "basic",
			});
			return;
		}

		const preFetchedData = { 
			subscriptionsData,
			availableGymsByRegion: availableGymsBy?.gyms_by_region ?? null,
			availableGymsByPrice: availableGymsBy?.gyms_by_price ?? null,
			availableGymsByCluster: availableGymsBy?.gyms_by_cluster ?? null,
			gymBillingPeriod
		};

		document.addEventListener("vgTableSubscriptionFilterChanged", (event) => {
			renderQuoteButtons(event.detail.filteredSubscriptions);
		});

		await initTable(gymId, preFetchedData);
		renderSubscriptions(subscriptionsData, countryPath);
		renderSubscriptionsExtras(subscriptionsData, countryPath);
		addFormEvents();
		checkFormSubmitButton();

		let preselectPopular = true;
		let preselectedByUrl = false;
		const urlParams = new URLSearchParams(window.location.search);
		const preselectedSubscription = urlParams.get('sub');
		if (preselectedSubscription) {
			const urlSubscription = VgSubscriptions.getSubscriptionByGlobalId(preselectedSubscription, subscriptionsData);

			if (urlSubscription) {
				const globalIdPreselected = urlSubscription.product.globalId;
				setSubscriptionFilterFor(urlSubscription);
				preselectedByUrl = preSelectSubscriptionByUrl(globalIdPreselected);
				preselectPopular = false;
			}
		}

		if (!preselectedByUrl) {
			cancelSkipQuote(skipQuote);
		}

		if (preselectPopular) {
			const featuredSubscription = VgSubscriptions.getFeaturedSubscription(subscriptionsData);
			preSelectMostPopularSubscription(progress, featuredSubscription);
		}

		if (progress) {
			progress.renderStepResume(vgForms);
			fillUserSubscriptions(userSubscriptions);
			//vgForms.removeLoading(subscriptionSelection);
		}
		if (marketingOptions?.banner) {
			renderGymBanner(marketingOptions);
		}

		if (marketingOptions?.maintenance) {
			renderMaintenanceMessage(marketingOptions);
		}
	}

	function clearStep(progress) {
		const step1resume = document.getElementById("step-1-resume");
		step1resume.innerHTML = progress?.getGymName();
		vgForms.removeLoading(step1resume);
		const form = document.querySelector(".vg-select-quote");
		form.innerHTML = '';
	}

	function fillUserSubscriptions(userSubscriptions) {
		deactiveNotifications();
		restoreSubscriptionFilterFromSelection(userSubscriptions);
		Object.keys(userSubscriptions).forEach((key) => {
			userSubscriptions[key].forEach((item) => {
				const value = item["value"];
				const selectedElement = document.querySelector(
					`input[name="${key}"][value="${value}"]`
				);
				if (key === 'vg-select-quote--clipcard') { // If clipcard we need to click his checkbox acceptance only if required
					let clipcardAcceptance = selectedElement?.parentElement.parentElement.querySelector('.vg-select-quote__clipcard-conditions input');
					clipcardAcceptance?.click();
				}
				selectedElement?.click();
			});
		});
		activeNotifications();
	}

	function restoreSubscriptionFilterFromSelection(userSubscriptions) {
		const selectedGlobalId = userSubscriptions['vg-select-quote']?.[0]?.globalId;
		if (!selectedGlobalId) return;

		const selectedSubscription = VgSubscriptions.getSubscriptionByGlobalId(selectedGlobalId, subscriptionsData);
		if (!selectedSubscription) return;

		setSubscriptionFilterFor(selectedSubscription);
	}

	function setSubscriptionFilterFor(subscription) {
		const isBinding = VgSubscriptions.isBindingSubscription(subscription);

		const lockInRadio = document.querySelector(
			`[name="lock-in"][value="${isBinding ? 'lock-in' : 'no-lock-in'}"]`
		);
		lockInRadio?.click();

		if (!isBinding) return;

		const months = VgSubscriptions.getBindingMonths(subscription);
		const monthsRadio = document.querySelector(`[name="subscription-selection"][value="${months}"]`);
		monthsRadio?.click();
	}

	function preSelectInsuranceClipcard(gymPreselectedInsurance, userSubscriptions, subscriptionsData) {
		const subscriptionInsuranceClipcard = subscriptionsData?.clipcards?.find(clipcard => clipcard.productGroupName.includes("INSURANCE"));
		const userHasInsuranceClipcard = userSubscriptions?.['vg-select-quote--clipcard']?.some(clipcard => clipcard.globalId.includes("INSURANCE"));

		if (gymPreselectedInsurance && subscriptionInsuranceClipcard && !userHasInsuranceClipcard) {
			const insuranceClipcardInput = document.querySelector(`.vg-select-quote__clipcard-item .vg-select-quote__clipcard-button input[data-global-id="${subscriptionInsuranceClipcard.productGroupName}"]`);
			const insuranceClipcardConditions = insuranceClipcardInput?.parentElement.parentElement.querySelector('.vg-select-quote__clipcard-conditions input');
			activePreselectMode();
			insuranceClipcardConditions?.click();
			insuranceClipcardInput?.click();
			deactivePreselectMode();
		}
	}

	/**
	 * Preselect the ?sub= subscription.
	 *
	 * @param {string} globalId Subscription global id.
	 * @returns {boolean} Whether the subscription has been preselected.
	 */
	function preSelectSubscriptionByUrl(globalId) {
		const subPreselectedRadio = document.querySelector(
			`input[name="vg-select-quote"][data-global-id="${globalId}"]`
		);
		if (subPreselectedRadio) {
			activePreselectMode();
			subPreselectedRadio.click();
			deactivePreselectMode();
			subPreselectedRadio.closest('.vg-select-quote__list-item')?.scrollIntoView({
				behavior: 'smooth',
				block: 'center'
			});
			return true;
		}
		return false;
	}

	/**
	 * NEW JOINING SWITCH: stay in the quote step when ?skip_quote=1 can't be done: the controller removes the loading.
	 *
	 * @param {boolean} skipQuote Whether ?skip_quote=1 is in the URL.
	 */
	function cancelSkipQuote(skipQuote) {
		if (skipQuote) {
			document.dispatchEvent(new CustomEvent("skipQuoteCancelled"));
		}
	}

	function preSelectMostPopularSubscription(progress, subscription) {
		const data = progress.getSelectQuoteStep().data;
		const userHasSubscription = Object.keys(data).length > 0;
		if (subscription && !userHasSubscription) {
			const mostPopularRadio = document.querySelector(
				`input[name="vg-select-quote"][value="${subscription.productId.id}"]`
			);
			activePreselectMode();
			mostPopularRadio?.click();
			deactivePreselectMode();
		}
	}

	function addSubscriptionsEvents() {
		let subscriptionRadios = [...document.querySelectorAll(
			'input[name="vg-select-quote"]'
		)].filter((radio) => !radio.dataset.eventsBound);

		subscriptionRadios.forEach((radio) => {
			radio.dataset.eventsBound = 'true';
			radio.addEventListener("click", (event) => {
				let data = {
					selectedKey: event.target.dataset.globalId,
					selectedName: event.target.dataset.productName ?? event.target.dataset.webname,
					selectedValue: event.target.value,
					selectedPrice: event.target.dataset.price,
					promotion: event.target.dataset.promotion,
					binding: parseInt(event.target.dataset.binding, 10) || 0,
				};

				if (currentSelectedRadio !== event.target) {
					if (currentSelectedRadio) {
						let previousData = {
							selectedKey: currentSelectedRadio.dataset.globalId,
							selectedName: currentSelectedRadio.dataset.productName ?? currentSelectedRadio.dataset.webname,
							selectedValue: currentSelectedRadio.value,
							selectedPrice: currentSelectedRadio.dataset.price,
							promotion: currentSelectedRadio.dataset.promotion,
							binding: parseInt(currentSelectedRadio.dataset.binding, 10) || 0,
						};
						let previousButtonLabel =
							currentSelectedRadio.nextElementSibling;
						let previousButtonLabelText = previousButtonLabel?.querySelector('.vg-select-quote__list-item-price-text');

						if (previousButtonLabelText) {
							previousButtonLabelText.innerHTML = previousButtonLabel.dataset.textUnchecked;
						} else if (previousButtonLabel?.dataset.ctaLabel) {
							previousButtonLabel.textContent = previousButtonLabel.dataset.ctaLabel;
						}

						document.dispatchEvent(
							new CustomEvent("removeSubscription", {
								detail: previousData,
							})
						);
					}

					currentSelectedRadio = event.target;

					document.dispatchEvent(
						new CustomEvent("addSubscription", { detail: data })
					);
				}
			});
		});
		subscriptionRadios.forEach((radio) => {
			const buttonQuote = radio.nextElementSibling;
			const buttonLabel = buttonQuote?.querySelector('.vg-select-quote__list-item-price-text');

			radio.addEventListener("change", async (event) => {
				preSelectInsuranceClipcard(gymPreselectedInsurance, userSubscriptions, subscriptionsData);

				if (buttonLabel) {
					buttonLabel.innerHTML = event.target.checked ? buttonQuote.dataset.textChecked : buttonQuote.dataset.textUnchecked;
				} else if (buttonQuote?.dataset.ctaLabel) {
					buttonQuote.textContent = event.target.checked ? buttonQuote.dataset.ctaLabelSelected : buttonQuote.dataset.ctaLabel;
				}

				checkTableStyles();
			});

			if (radio.checked) {
				if (buttonLabel) {
					buttonLabel.innerHTML = buttonQuote.dataset.textChecked;
				} else if (buttonQuote?.dataset.ctaLabel) {
					buttonQuote.textContent = buttonQuote.dataset.ctaLabelSelected;
				}
			}
		});
	}

	function checkTableStyles() {
		const table = document.querySelector('.vg-select-quote__table table.vg-table');
		const headItems = table.querySelectorAll('thead tr th');
		const bodyItems = table.querySelectorAll('tbody tr');
		
		// Reset all styles
		headItems.forEach((th, index) => {
			th.classList.remove('quote-featured');
			const button = th.querySelector('.item-cta');
			if (button) {
				button.className = 'item-cta ob-button ob-button--secondary ob-button--outline ob-button--pill ob-button--compact';
			}
		});
		bodyItems.forEach((tr) => {
			const td = tr.querySelectorAll('td');
			td.forEach((cell) => cell.classList.remove('quote-featured'));
		});


		// Search checked column 
		let checkedColumnIndex = -1;
		headItems.forEach((th, index) => {
			const headRadio = th.querySelector('input[name="vg-select-quote"]');
			if (headRadio && headRadio.checked) {
				checkedColumnIndex = index;
			}
		});

		// Change styles on checked column
		if (checkedColumnIndex >= 0 ) {
			if (undefined !== headItems[checkedColumnIndex]) {
				headItems[checkedColumnIndex].classList.add('quote-featured');
				headItems[checkedColumnIndex].querySelector('.item-cta').className = 'item-cta ob-button ob-button--pill ob-button--compact';
			}
			bodyItems.forEach((tr) => {
				const td = tr.querySelectorAll('td')[checkedColumnIndex];
				if (td && td.getAttribute("colspan") === null) {
					td.classList.add('quote-featured');
				}
			});
		}
	}

	function renderSubscriptionsExtras(subscriptionsData, countryPath) {
		document.addEventListener("addSubscription", (event) => {
			const selectedSubscriptionGlobalId = event.detail.selectedKey;

			const subscriptionData = VgSubscriptions.getSubscriptionByGlobalId(
				selectedSubscriptionGlobalId,
				subscriptionsData
			);
			if (subscriptionData) {
				updatePromotionBanner(subscriptionData);
				VgTable.updateCreationPriceRow([subscriptionData]);
			}

			renderAddons(subscriptionsData, selectedSubscriptionGlobalId);
			if (!VgSubscriptions.isDaypassSubscription(subscriptionData)) {
				renderClipcards(subscriptionsData, countryPath);
			} else {
				const clipcardsContainer = document.querySelector(
					".vg-select-quote__clipcard-list"
				);
				clipcardsContainer.innerHTML = "";
			}
		});
	}

	function addAddonsEvents() {
		let addonsCheckboxes = document.querySelectorAll(
			'input[name="vg-select-quote--addons"]'
		);
		addonsCheckboxes.forEach((addon) => {
			addon.addEventListener("change", (event) => {
				let data = {
					selectedKey: event.target.dataset.globalId,
					selectedName: event.target.dataset.webname,
					selectedValue: event.target.value,
					selectedPrice: event.target.dataset.price,
				};
				const buttonLabel = addon.nextElementSibling;
				if (event.target.checked) {
					buttonLabel.innerHTML = buttonLabel.dataset.textChecked;
					document.dispatchEvent(
						new CustomEvent("addAddon", { detail: data })
					);
				} else {
					buttonLabel.innerHTML = buttonLabel.dataset.textUnchecked;
					document.dispatchEvent(
						new CustomEvent("removeAddon", { detail: data })
					);
				}
			});
		});
	}

	function addClipcardsEvents(countryPath) {

		const clipcards = document.querySelectorAll('.vg-select-quote__clipcard-item');

		clipcards.forEach((clipcard) => {
			const clipcardAcceptance = clipcard.querySelector('.vg-select-quote__clipcard-conditions input');
			const clipcardButton = clipcard.querySelector('.vg-select-quote__clipcard-button input');
			const clipcardButtonLabel = clipcard.querySelector('.vg-select-quote__clipcard-button label');

			clipcardAcceptance?.addEventListener("change", (event) => {
				clipcardButton.dataset.acceptConditions = clipcardAcceptance.checked;
				clipcardButton.disabled = !clipcardAcceptance.checked;

				if (clipcardAcceptance.checked) {
					clipcardButtonLabel.removeAttribute("disabled");
				} else {
					clipcardButtonLabel.setAttribute("disabled", "true");
					clipcardButton.checked = false;
				}
			});

			clipcardButton?.addEventListener("change", (event) => {
				let data = {
					selectedKey: event.target.dataset.globalId,
					selectedName: event.target.dataset.webname,
					selectedValue: event.target.value,
					selectedPrice: event.target.dataset.price,
					acceptConditions: clipcardAcceptance ? clipcardAcceptance.checked : null,
				};

				if (clipcardButton.checked) {
					clipcardAcceptance?.setAttribute("disabled", "true");

					clipcardButtonLabel.textContent = clipcardButtonLabel.getAttribute("data-text-checked");
					document.dispatchEvent(
						new CustomEvent("addClipcard", { detail: data })
					);
				} else {
					clipcardAcceptance?.removeAttribute("disabled");
					clipcardButtonLabel.textContent = clipcardButtonLabel.getAttribute("data-text-unchecked");
					document.dispatchEvent(
						new CustomEvent("removeClipcard", { detail: data })
					);
				}
			});
		});
	}

	function uncheckAllSelectedClipcards(clipcards, event) {
		clipcards?.forEach((clipcard) => {
			if (clipcard !== event?.target.parentElement.parentElement && clipcard.querySelector('.vg-select-quote__clipcard-button input').checked) {
				const clipcardButton = clipcard.querySelector('.vg-select-quote__clipcard-button input');
				const clipcardButtonLabel = clipcard.querySelector('.vg-select-quote__clipcard-button label');
				const clipcardAcceptance = clipcard.querySelector('.vg-select-quote__clipcard-conditions input');

				clipcardAcceptance?.removeAttribute("disabled");
				clipcardButton.checked = false;
				clipcardButtonLabel.textContent = clipcardButtonLabel.getAttribute("data-text-unchecked");

				const data = {
					selectedKey: clipcardButton.dataset.globalId,
					selectedName: clipcardButton.dataset.webname,
					selectedValue: clipcardButton.value,
				};
				document.dispatchEvent(
					new CustomEvent("removeClipcard", { detail: data })
				);
			}
		});
	}

	function addFormEvents() {
		const formQuote = document.querySelector(".vg-select-quote__form");

		formQuote.addEventListener("submit", (event) => {
			event.preventDefault();

			const data = checkFormData(formQuote);

			document.dispatchEvent(
				new CustomEvent("formSubscriptionSubmit", { detail: data })
			);
		});

		formQuote.addEventListener("change", (event) => {
			const skipFields = [ "vg_select_quote_nonce", "_wp_http_referer", "lock-in", "subscription-selection" ];

			if (skipFields.includes(event.target.name) || event.target.name.startsWith("vg-select-quote--clipcard-acceptance-")) {
				return;
			}
			checkFormSubmitButton();

			const data = checkFormData(formQuote);

			document.dispatchEvent( 
				new CustomEvent("formSubscriptionUpdated", { detail: data })
			);
		});
	}

	function checkFormData(formQuote) {
		const formData = new FormData(formQuote);
		const data = {};

		for (const [name, value] of formData) {
			const inputElement = formQuote.querySelector(
				`input[name="${name}"][value="${value}"]`
			);

			if (!data[name]) {
				data[name] = [];
			}

			const globalId = inputElement.dataset.globalId;
			const webname = inputElement.dataset.webname;
			const type = inputElement.dataset.type;
			const price = inputElement.dataset.price;

			const itemData = { value, webname, globalId, type, price };

			if (inputElement.dataset.promotion) {
				itemData.promotion = inputElement.dataset.promotion;
			}

			if (inputElement.dataset.binding !== undefined) {
				itemData.binding = parseInt(inputElement.dataset.binding, 10) || 0;
			}

			if (inputElement.dataset.acceptConditions !== undefined) {
				itemData.acceptConditions = inputElement.dataset.acceptConditions === 'true';
			}

			data[name].push(itemData);
		}

		return data;
	}

	function checkFormSubmitButton() {
		const formQuote = document.querySelector(".vg-select-quote__form");
		const formData = new FormData(formQuote);
		const vgSelectQuoteSubmit = document.querySelector(
			".vg-select-quote__submit"
		);
		let selectedSubscription = false;
		for (const [name, value] of formData) {
			if (name == "vg-select-quote") {
				selectedSubscription = true;
			}
		}
		if (selectedSubscription) {
			vgSelectQuoteSubmit.disabled = false;
		} else {
			vgSelectQuoteSubmit.disabled = true;
		}
	}

	function renderGymBanner(marketingOptions) {
		if (!marketingOptions.banner_image) return;

		const bannerContainer = document.querySelector(".vg-select-quote__banner");
		const templateSelection = marketingOptions.banner_url ? "#gym-banner-template" : "#gym-banner-template--no-link";
		const template = document.querySelector(`${templateSelection}`);
		const clone = template.content.cloneNode(true);
		const img = clone.querySelector('slot[name="banner-image"]');

		if (!marketingOptions.banner_image_mobile) {
			img.outerHTML =
				`<img
					src="${marketingOptions.banner_image.sizes.full?.url || marketingOptions.banner_image.url}"
					width="${marketingOptions.banner_image.sizes.full?.width || marketingOptions.banner_image.width}"
					height="${marketingOptions.banner_image.sizes.full?.height || marketingOptions.banner_image.height}"
					srcset="${marketingOptions.banner_image.srcset}"
					sizes="${marketingOptions.banner_image.srcset_sizes}"
					alt="${marketingOptions.banner_image.alt}"
					class="vg-select-quote__banner-image"
					loading="eager"
					fetchpriority="high"
					decoding="sync"
				/>`;
		}

		if (marketingOptions.banner_image_mobile) {
			img.outerHTML =
				`<picture>
					<source
						media="(min-width: 768px)"
						srcset="${marketingOptions.banner_image.srcset}"
						sizes="${marketingOptions.banner_image.srcset_sizes}" />
					<img
						src="${marketingOptions.banner_image_mobile.url}"
						srcset="${marketingOptions.banner_image_mobile.srcset}"
						sizes="${marketingOptions.banner_image_mobile.srcset_sizes}"
						alt="${marketingOptions.banner_image.alt}"
						loading="eager"
						fetchpriority="high"
						decoding="sync"
						width="${marketingOptions.banner_image_mobile.width}"
						height="${marketingOptions.banner_image_mobile.height}"
						class="vg-select-quote__banner-image" />
				</picture>`
		}

		if (marketingOptions.banner_url.url) {
			const bannerLink = clone.querySelector('.vg-select-quote__banner-link');
			bannerLink.href = marketingOptions.banner_url.url;
			bannerLink.target = marketingOptions.banner_url.target || '_self';
		}


		if (marketingOptions.banner_text) {
			const bannerText = clone.querySelector('slot[name="banner-text"]');
			bannerText.outerHTML = marketingOptions.banner_text;
		}

		if (marketingOptions.banner_image || marketingOptions.banner_text) {
			bannerContainer.appendChild(clone);
		}
	}

	function renderMaintenanceMessage(marketingOptions) {
		if (marketingOptions.maintenance) {
			const maintenanceContainer = document.querySelector(".vg-select-quote__maintenance");
			const template = document.querySelector("#gym-maintenance-template");
			const clone = template.content.cloneNode(true);
			const maintenanceText = clone.querySelector('slot[name="maintenance-message"]');

			maintenanceText.outerHTML = marketingOptions.maintenance_message;

			maintenanceContainer.appendChild(clone);
		}
	}

	async function initTable(gymId, prefetchedGymData) {
		const table = new VgTable(gymId, prefetchedGymData);
		await table.tableReady;
		return table;
	}

	function updateCreationPrice(subscription) {
		const registrationContainer = document.querySelector(
			".vg-select-quote__list-detail"
		);
		const registrationFee = registrationContainer.querySelector(
			".vg-select-quote__registration"
		);
		const registrationPrice = registrationFee.querySelector("[data-slot]");
		const registrationPricePromoted = registrationFee.querySelector(
			"[data-slot-promotion]"
		);
		const registrationPriceEnd =
			registrationFee.querySelector("[data-slot-end]");

		let isCreationPromoted = false;
		let isCreationPriceZero = false;

		if (subscription) {
			isCreationPromoted =
				subscription.creationPrice != subscription.creationNormalPrice
					? true
					: false;
			isCreationPriceZero =
				subscription.creationPrice == "0.00" ? true : false;

			registrationPrice.innerHTML = subscription.creationNormalPrice + "€";
		}

		if (isCreationPromoted) {
			registrationPrice.classList.add("vg-select-quote__underline-text");
		} else {
			registrationPrice.classList.remove(
				"vg-select-quote__underline-text"
			);
		}

		if (isCreationPriceZero) {
			registrationPriceEnd.classList.remove("disabled");
		} else {
			registrationPriceEnd.classList.add("disabled");
		}

		if (isCreationPromoted && !isCreationPriceZero) {
			registrationPricePromoted.innerHTML =
				subscription.creationPrice + "€";
		} else {
			registrationPricePromoted.innerHTML = "";
		}
	}

	function updatePromotionBanner(subscription) {
		// TODO: WIP update promotion banner.
		const promotionBanner = document.querySelector(
			".vg-select-quote__promotion"
		);
		const promotionText = promotionBanner.querySelector("[data-slot]");

		let isCreationPromoted = false;
		if (subscription) {
			isCreationPromoted =
				subscription.creationPrice != subscription.creationNormalPrice
					? true
					: false;
		}
		if (isCreationPromoted) {
			promotionBanner.classList.remove("disabled");
			promotionText.innerHTML = subscription?.creationPriceText || subscription?.proRataPriceText;
		} else {
			promotionBanner.classList.add("disabled");
		}
	}

	function renderSubscriptions(subscriptionsData, country) {
		// Initially we show creation and promotion banner of the most popular subscription
		const featuredSubscription = VgSubscriptions.getFeaturedSubscription(subscriptionsData);
		updatePromotionBanner(featuredSubscription);

		const currentLockIn = document.querySelector('[name="lock-in"]:checked')?.value;
		const currentMonths = document.querySelector('[name="subscription-selection"]:checked')?.value;
		renderQuoteButtons(VgSubscriptions.filterByLockAndDuration(subscriptionsData, currentLockIn, currentMonths));
		renderStudentSubscription(subscriptionsData);
		renderDayPassSubscriptions(subscriptionsData, country);
	}

	function renderPromotionConditions(subscription, countryPath) {
		const promotionConditions = document.querySelector(".vg-select-quote__promotion-conditions");
		if (!promotionConditions) return;

		// TODO: ensure that we want creationPriceSource or campaignSource
		if (!subscription.creationPriceSource) {
			promotionConditions.innerHTML = "";
			return;
		}

		let promoLink = isGymOpen
			? JoiningVars.get_setting_field("vg_link_promo", countryPath, "step-settings", "settings")
			: JoiningVars.get_setting_field("vg_link_promo_preopening", countryPath, "step-settings", "settings");

		promotionConditions.innerHTML = `
			<div class="vg-select-quote__description-promotion">
				<p>${JoiningVars.get_form_field("promo-link-terms")}</p>
			</div>
		`;
		const linkConditions = promotionConditions.querySelector('a');
		if (linkConditions) {
			linkConditions.setAttribute('id', 'vg-select-quote__promotions-link-conditions');
			linkConditions.setAttribute('target', '_blank');
			linkConditions.setAttribute('href', promoLink);
		}
	}

	function renderStudentSubscription(subscriptionsData) {
		const studentSubscriptions = VgSubscriptions.getStudentSubscriptions(subscriptionsData);

		if (studentSubscriptions.length === 0) {
			return;
		}

		const studentContainer = document.querySelector('.vg-table__student-subscription');

		if (!studentContainer) return;

		const template = document.querySelector("#student-template");

		if (!template) return;

		studentSubscriptions.forEach((sub) => {
			const clone = template.content.cloneNode(true);
			const studentContainerProduct = clone.querySelector(".vg-compare-table_student__quote");
			studentContainerProduct.setAttribute("data-global-id", sub.product.globalId);

			const radio = document.createElement("input");
			radio.type = "radio";
			radio.name = "vg-select-quote";
			radio.className = "vg-hidden-radio";
			radio.id = `vg-select-quote--${sub.product.webname}`;
			radio.value = sub.productId.id;
			radio.dataset.globalId = sub.product.globalId;
			radio.dataset.webname = sub.product.webname;
			radio.dataset.type = sub.product.type;
			radio.dataset.price = sub.periodPrice;
			radio.dataset.promotion = sub.creationPriceText ?? '';
			radio.dataset.binding = sub.bindingPeriodLength ?? 0;

			const footerLabel = clone.querySelector(".vg-compare-table_student_footer_link span");
			footerLabel.before(radio);

			studentContainerProduct.addEventListener("click", (event) => {
				if (event.target === radio) return;
				radio.click();
			});

			const subscriptionPrice = `${VgHelpers.getBillingPeriodPrice(sub.periodPrice, gymBillingPeriod)}€` + `/${VgHelpers.getBillingPeriodLabel(gymBillingPeriod)}`;
			const priceProduct = clone.querySelector(".vg-compare-table_student_description_price");
			priceProduct.innerHTML = subscriptionPrice;

			studentContainer.appendChild(clone);
		});

		addSubscriptionsEvents();
	}

	function renderDayPassSubscriptions(subscriptionsData, countryPath) {
		const dayPassSubscriptions = VgSubscriptions.getDayPassSubscriptions(subscriptionsData);

		if (dayPassSubscriptions.length === 0) {
			return;
		}

		const quoteContainer = document.querySelector(".vg-select-quote__daypass");

		dayPassSubscriptions.forEach((subscription) => {
			const product = getProductFromCollectionByGlobalId(subscription.product.globalId);

			const subscriptionElement = document.createElement("div");
			subscriptionElement.classList.add("vg-select-quote__list-item", "item-quote-special");

			if (product?.image_html) {
				subscriptionElement.innerHTML += `${product.image_html}`;
				subscriptionElement.querySelector('img').classList.add('vg-select-quote__subscription-image');
			}

			renderPromotionConditions(subscription, countryPath);

			const dayPassDescription = `<p>${product?.description ? product.description : JoiningVars.get_form_field("pase-dia-texto")}</p>`;

			subscriptionElement.innerHTML += `<div class="vg-select-quote__list-item-name">
				<div class="vg-select-quote__list-item-label has-subtitle-s-font-size">
					${product?.title ? product.title : subscription.product.webname}
				</div>
				<div class="vg-select-quote__list-item-price has-h-3-font-size">
					<span data-price="${priceFormat(subscription.periodPrice)}" data-slot>${priceFormat(subscription.periodPrice)}</span><span>€</span>
				</div>
				${dayPassDescription}
			</div>`;

			const btnText = `${JoiningVars.get_form_field("quiero-seleccionar")} ${product?.title ? product.title : subscription.product.webname}`;
			const btnTextChecked = `${JoiningVars.get_form_field("added-cuota")}`;

			subscriptionElement.innerHTML += `
			<div class="vg-select-quote__list-item-button">
				<input type="radio"
						id="vg-select-quote--${subscription.product.webname}"
						name="vg-select-quote" value="${subscription.productId.id}"
						data-global-id="${subscription.product.globalId}"
						data-webname="${subscription.product.webname}"
						data-type="${subscription.product.type}"
						data-price="${subscription.periodPrice}"
						data-promotion="${subscription.creationPriceText ?? ''}"
						data-binding="${subscription.bindingPeriodLength ?? 0}"
						>
				<label for="vg-select-quote--${subscription.product.webname}"
						data-text-checked="${btnTextChecked}"
						data-text-unchecked="${btnText}"
						class="ob-button ob-button--secondary">
						<span class="vg-select-quote__list-item-price-text">${btnText}</span>
				</label>
			</div>
			`;

			quoteContainer.appendChild(subscriptionElement);
		});

		addSubscriptionsEvents();
	}

	function renderQuoteButtons(filteredSubscriptions) {
		const allColumns = [...document.querySelectorAll(".vg-table thead [data-col-index]")];
		const ctaTemplate = document.getElementById('vg-table-cta-template');

		allColumns.forEach((column) => {
			column.querySelector('.vg-select-quote__cta')?.remove();

			if (column.style.display === 'none') return;

			const subscription = filteredSubscriptions[column.dataset.colIndex];
			if (!subscription) return;

			const cta = ctaTemplate.content.cloneNode(true);
			const radio = cta.querySelector('input[name="vg-select-quote"]');
			const label = cta.querySelector('label');
			const itemPrice = cta.querySelector('.item-price');
			const itemPriceLabel = cta.querySelector('.item-price-label');
			const itemPricePromo = cta.querySelector('.item-price-promo');

			radio.id = `vg-select-quote--${subscription.product.webname}`;
			radio.value = subscription.productId.id;
			radio.dataset.globalId = subscription.product.globalId;
			radio.dataset.webname = subscription.product.webname;
			radio.dataset.productName = subscription.product.name.trim();
			radio.dataset.type = subscription.product.type;
			radio.dataset.price = subscription.periodPrice;
			radio.dataset.promotion = subscription.creationPriceText ?? '';
			radio.dataset.binding = subscription.bindingPeriodLength ?? 0;

			if (currentSelectedRadio?.dataset.globalId === subscription.product.globalId) {
				radio.checked = true;
				currentSelectedRadio = radio;
			}

			label.setAttribute('for', radio.id);

			const isSubscriptionPromoted = subscription?.proRataPriceSource ? true : false;
			const displayPrice = isSubscriptionPromoted ? subscription.proRataPrice : subscription.periodPrice;

			if (isSubscriptionPromoted) {
				itemPricePromo.textContent = `${VgHelpers.getBillingPeriodPrice(subscription.periodPrice, gymBillingPeriod)}€`;
				itemPricePromo.classList.add('vg-select-quote__underline-text');
			} else {
				itemPricePromo.textContent = '';
				itemPricePromo.classList.remove('vg-select-quote__underline-text');
			}

			itemPrice.textContent = `${VgHelpers.getBillingPeriodPrice(displayPrice, gymBillingPeriod)}€`;

			itemPriceLabel.textContent = `/${VgHelpers.getBillingPeriodLabel(gymBillingPeriod)}`;
			column.append(cta);
		});

		addSubscriptionsEvents();
		checkTableStyles();
	}

	function renderAddons(subscriptionsData, quoteGlobalId) {
		const addonsSection = document.querySelector(
			".vg-select-quote__addons"
		);
		addonsSection.innerHTML = "";

		const addonsContainer = document.createElement("div");
		addonsContainer.classList.add("vg-select-quote__container");
		addonsContainer.classList.add("vg-select-quote__addons-container");
		addonsSection.appendChild(addonsContainer);

		const title_addons = document.createElement("h2");
		title_addons.classList.add("vg-select-quote__addons-title");
		title_addons.classList.add("has-h-2-font-size");
		title_addons.innerHTML = addonsSection.dataset.title;
		addonsContainer.append(title_addons);

		const listAddonsContainer = document.createElement("div");
		listAddonsContainer.classList.add("vg-select-quote__addons-list");
		addonsContainer.appendChild(listAddonsContainer);

		//TODO: this foreach shoudn't be, we should use the subscription selected
		subscriptionsData.subscriptions.forEach((subscription) => {

			if (subscription.product.globalId !== quoteGlobalId) {
				return;
			}

			if (VgSubscriptions.isDaypassSubscription(subscription)) {
				hideAddons();
				hideClipcards();
				return;
			}

			if (!subscription.availableAddOnProducts) {
				hideAddons();
				return;
			}

			showAddons();
			subscription.availableAddOnProducts.forEach((addon) => {
				const product = getProductFromCollectionByGlobalId(addon.productGroupName);

				const addonElement = document.createElement("div");
				addonElement.classList.add("vg-select-quote__addons-item");

				if (!product) { // TODO: remove this fallback when cpt is widelly used
					let addonImage = "demo-addons";
					if (waterGlobalId.includes(addon.productGroupName)) {
						addonImage = "yanga-sport";
					}
					if (lockerGlobalId.includes(addon.productGroupName)) {
						addonImage = "alquiler-taquilla";
					}
					addonElement.innerHTML += getProductImageHtmlElement(addonImage, addon.name, 'addons');
				}

				if (product?.image_html) {
					const tempContainer = document.createElement('div');
					tempContainer.innerHTML = product.image_html;
					const imgElement = tempContainer.querySelector('img');
					imgElement.classList.add('vg-select-quote__addons-image');

					addonElement.appendChild(imgElement);
				}

				let str_price_month = JoiningVars.get_form_field("precio-mes");
				let str_price_week = JoiningVars.get_form_field("precio-semana");
				let str_add_to_quote = JoiningVars.get_form_field("add-mi-cuota");
				let str_remove_from_quote = JoiningVars.get_form_field("delete-mi-cuota");

				addonElement.innerHTML += `
				<div>
					<h3 class="vg-select-quote__addons-item-title">${product?.title || addon.webname}</h3>
					${product?.description || '<p>' + addon.description + '</p>'}
					<div class="vg-select-quote__addons-price has-h-3-font-size">
						<span data-price="${addon.normalPeriodPrice ?? addon.normalPrice}">
							${VgHelpers.getBillingPeriodPrice(addon.normalPeriodPrice ?? addon.normalPrice, gymBillingPeriod)}
						</span>
						<span data-price-unit>€ / ${VgHelpers.getBillingPeriodLabel(gymBillingPeriod)}</span>
					</div>
				</div>
				`;

				addonElement.innerHTML += `
				<div class="vg-select-quote__addons-button">
					<input  type="checkbox"
							id="vg-select-quote--${addon.productGroupName}"
							name="vg-select-quote--addons"
							value="${addon.productId}"
							data-global-id="${addon.productGroupName}"
							data-webname="${addon.webname}"
							data-price="${addon.normalPeriodPrice ?? addon.normalPrice}"
							data-price-slot>
					<label  for="vg-select-quote--${addon.productGroupName}"
							class="ob-button ob-button--primary"
							data-text-unchecked="${str_add_to_quote}"
							data-text-checked="${str_remove_from_quote}"
							>
							${str_add_to_quote}
					</label>
				</div>
				`;

				listAddonsContainer.appendChild(addonElement);
			});
		});
		addAddonsEvents();
	}

	function renderClipcards(subscriptionsData, countryPath) {

		if (subscriptionsData.clipcards.length === 0) {
			hideClipcards();
			return;
		}

		const clipcardsContainer = document.querySelector(
			".vg-select-quote__clipcard-list"
		);
		clipcardsContainer.innerHTML = "";

		showClipcards();
		subscriptionsData.clipcards.forEach((clipcard) => {
			const product                   = getProductFromCollectionByGlobalId(clipcard.productGroupName);
			const hasDiscount               = Number(clipcard?.price) < Number(clipcard?.normalPrice);
			const hasConditions             = !product || Boolean(product?.conditions);
			const hasExtraDescription       = Boolean(product?.extra_description);

			const addonElement = document.createElement("div");
			addonElement.classList.add("vg-select-quote__clipcard-item");

			if (!product) { // TODO: remove this fallback when cpt is widelly used
				addonElement.innerHTML += getProductImageHtmlElement('one-experience', clipcard.name, 'clipcard');
			}

			if (product?.image_html) {
				const tempContainer = document.createElement('div');
				tempContainer.innerHTML = product.image_html;
				const imgElement = tempContainer.querySelector('img');
				imgElement.classList.add('vg-select-quote__clipcard-image');

				addonElement.appendChild(imgElement);
			}

			let str_add_to_quote = JoiningVars.get_form_field("comprar-mi-cuota");;
			let str_remove_from_quote = JoiningVars.get_form_field("delete-mi-cuota");;

			addonElement.innerHTML += `
			<div>
				<h3 class="vg-select-quote__clipcard-title has-h-3-font-size">${product?.title || clipcard.name}</h3>
				<div class="vg-select-quote__clipcard-description">
					${product?.description ||
				`<p>${JoiningVars.get_form_field("clipcard-parrafo")}</p>
					<ul>
						${JoiningVars.get_form_field("clipcard-lista").map((item) => `<li>${item}</li>`).join('')}
					</ul>`
				}
				</div>
				<div class="vg-select-quote__cilpcard-prices">
					<div class="vg-select-quote__cilpcard-price has-h-3-font-size">${priceFormat(clipcard.price)}€</div>
					${hasDiscount ? `<div class="vg-select-quote__cilpcard-price-promotion has-h-4-font-size vg-select-quote__underline-text">${priceFormat(clipcard.normalPrice)}€</div>` : ''}
				</div>
			</div>
			`;

			if (hasExtraDescription) {
				addonElement.innerHTML += `
					<div class="vg-select-quote__clipcard-extra-description">
						${product?.extra_description}
					</div>
				`;
			}

			if (hasConditions) {
				addonElement.innerHTML += `
					<div class="vg-select-quote__clipcard-conditions vg-form__field-group-checkbox">
						<input  type="checkbox" id="vg-select-quote--clipcard-acceptance-${clipcard.productId.id}"
							name="vg-select-quote--clipcard-acceptance-${clipcard.productId.id}"
							value="clipcard-acceptance-${clipcard.productId.id}">
						<label for="vg-select-quote--clipcard-acceptance-${clipcard.productId.id}"
							class="vg-select-quote__clipcard-conditions-label">${product?.conditions || JoiningVars.get_form_field("clipcard-condiciones")}
						</label>
					</div>
					`;
			}

			addonElement.innerHTML += `
			<div class="vg-select-quote__clipcard-button">
				<input type="checkbox"
				id="vg-select-clipcard-${clipcard.productId.id}"
				name="vg-select-quote--clipcard"
				value="${clipcard.productId.id}"
				data-global-id="${clipcard.productGroupName}"
				data-webname="${clipcard.webname}"
				data-price="${clipcard.price}"
				${hasConditions ? 'disabled' : ''}>
				<label for="vg-select-clipcard-${clipcard.productId.id}"
				class="ob-button ob-button--primary" ${hasConditions ? 'disabled' : ''}
				data-text-unchecked="${str_add_to_quote}"
				data-text-checked="${str_remove_from_quote}">
				${str_add_to_quote}
				</label>
			</div>
			`;

			clipcardsContainer.appendChild(addonElement);
			if (!product) { // TODO: remove this fallback when cpt is widelly used
				const clipcardAcceptance = addonElement.querySelector(".vg-select-quote__clipcard-conditions-label a");
				clipcardAcceptance?.setAttribute('href', JoiningVars.get_setting_field('vg_link_one_experience_terms', countryPath, 'step-settings', 'settings'));
			}
		});
		addClipcardsEvents(countryPath);
	}

	function getProductImageHtmlElement(imageName, imageAlt, productType) {
		const sourceRoute = '/wp-content/plugins/vivagym-joining/steps/../assets/images';
		const ext = 'webp';

		let imageHtml = `
			<img class="vg-select-quote__${productType}-image"
			width="300" height="168"
			src="${sourceRoute}/${imageName}-300x168.${ext}"
			loading="lazy"
			decoding="async"
			srcset="${sourceRoute}/${imageName}.${ext} 504w, ${sourceRoute}/${imageName}-300x168.${ext} 300w"
			sizes="(min-width: 401px) 504px, (max-width: 400px) 300px, 100vw"
			alt="${imageAlt}">
		`;

		return imageHtml;
	}

	function hideAddons() {
		document.querySelector('.vg-select-quote__addons').style.display = "none";
	}

	function hideClipcards() {
		document.querySelector('.vg-select-quote__clipcard').style.display = "none";
	}

	function showAddons() {
		document.querySelector('.vg-select-quote__addons').style.display = "block";
	}

	function showClipcards() {
		document.querySelector('.vg-select-quote__clipcard').style.display = "block";
	}

	function getProductFromCollectionByGlobalId(globalId) {
		return productsCollection?.find(product => product.global_id.includes(globalId));
	}

	function activeNotifications() {
		window.notificationsActive = true;
		window.loadMode = false;
	}

	function deactiveNotifications() {
		window.notificationsActive = false;
		window.loadMode = true;
	}

	function activePreselectMode() {
		window.notificationsActive = false;
		window.preSelectMode = true;
	}

	function deactivePreselectMode() {
		window.notificationsActive = true;
		window.preSelectMode = false;
	}

	function priceFormat(price) {
		if (typeof price === "number" || !isNaN(price)) {
			price = parseFloat(price).toFixed(2);
		}

		if (typeof price !== "string") {
			price = price.toString();
		}

		if (price === "0.00" || price === "0") {
			price = "00.00";
		}

		return price.replace(".", ",");
	}

});
